import { ROUTES } from "../constants";
import { apiRequest } from "./api.client";
import type {
  InvoiceCreate,
  InvoiceUpdate,
  InvoiceResponse,
  InvoicePdfResponse,
  RecordPaymentPayload,
} from "../schemas/invoice.schema";

export { ApiError as InvoiceApiError } from "./api.errors";

export async function createInvoice(
  visitId: string,
  data: InvoiceCreate
): Promise<InvoiceResponse> {
  return apiRequest<InvoiceResponse>(ROUTES.INVOICE_CREATE(visitId), {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function getInvoice(invoiceId: string): Promise<InvoiceResponse> {
  return apiRequest<InvoiceResponse>(ROUTES.INVOICE(invoiceId));
}

export async function updateInvoice(
  invoiceId: string,
  data: InvoiceUpdate
): Promise<InvoiceResponse> {
  return apiRequest<InvoiceResponse>(ROUTES.INVOICE(invoiceId), {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export async function sendInvoice(invoiceId: string): Promise<InvoiceResponse> {
  return apiRequest<InvoiceResponse>(ROUTES.INVOICE_SEND(invoiceId), {
    method: "POST",
  });
}

export async function recordPayment(
  invoiceId: string,
  data: RecordPaymentPayload
): Promise<InvoiceResponse> {
  return apiRequest<InvoiceResponse>(ROUTES.INVOICE_RECORD_PAYMENT(invoiceId), {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function getInvoicePdf(invoiceId: string): Promise<InvoicePdfResponse> {
  return apiRequest<InvoicePdfResponse>(ROUTES.INVOICE_PDF(invoiceId));
}

export async function getPatientInvoices(patientId: string): Promise<InvoiceResponse[]> {
  return apiRequest<InvoiceResponse[]>(ROUTES.PATIENT_INVOICES(patientId));
}

export async function sendInvoiceWhatsapp(invoiceId: string): Promise<{ status: string; channel: string; recipient: string }> {
  return apiRequest(ROUTES.INVOICE_SEND_WHATSAPP(invoiceId), { method: "POST" });
}

export async function sendInvoiceEmail(invoiceId: string): Promise<{ status: string; channel: string; recipient: string }> {
  return apiRequest(ROUTES.INVOICE_SEND_EMAIL(invoiceId), { method: "POST" });
}

export interface MarkAsPaidPayload {
  payment_method: "cash" | "upi" | "cheque" | "bank_transfer" | "other";
  payment_reference?: string;
  paid_at?: string;
  amount_collected_paise?: number;
}

export async function markAsPaid(
  invoiceId: string,
  data: MarkAsPaidPayload
): Promise<InvoiceResponse> {
  return apiRequest<InvoiceResponse>(ROUTES.INVOICE_MARK_PAID(invoiceId), {
    method: "POST",
    body: JSON.stringify(data),
  });
}
